import React from 'react';
import Icon from './Icon';

const MenuIcon = (props) => (
    <Icon {...props}>
        <path
            d="M8 8H16M8 12H13M8 16H16M12 2A10 10 0 1 1 2 12"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default MenuIcon;